import { render, staticRenderFns } from "./divideTitle.vue?vue&type=template&id=79ee7a06&scoped=true"
import script from "./divideTitle.vue?vue&type=script&lang=js"
export * from "./divideTitle.vue?vue&type=script&lang=js"
import style0 from "./divideTitle.vue?vue&type=style&index=0&id=79ee7a06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ee7a06",
  null
  
)

export default component.exports